var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserLayerGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.571a2.286 2.286 0 100-4.57 2.286 2.286 0 000 4.57zm3.143 4.572a.857.857 0 00.857-.857v-.743a2.4 2.4 0 00-2.4-2.4h-.298a3.112 3.112 0 01-2.604 0H10.4a2.4 2.4 0 00-2.4 2.4v.743c0 .473.384.857.857.857h6.286z",
    fill: "#24C0DB",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/bdc0ddb3f135b01bce08e4078a3eae2a-userLayerGroup.svg";
export { SvgUserLayerGroup as ReactComponent };